import { DatePicker, Form, Input } from "antd";
import { ProFormDatePicker, ProFormText } from "@ant-design/pro-form";
import request from "../../../../../../utils/request";
import qs from "qs";
export const getCompanyList = {
  key: "getCompanyList",
  config: {
    name: "批而未供土地",
    title: "批而未供",
    filter: {
      child: () => {
        // eslint-disable-next-line react/jsx-key
        return [
          <ProFormText placeholder="请输入地块名称" name="keys" key="keys" />,
          <ProFormText placeholder="请输入地块名称" name="keys1" key="keys1" />,
        ];
      },
      // beforeFilter(data) {
      //     data.years = moment(data.years).format('YYYY');
      //     return data;
      //   },
    },
    table: {
      pageSize: 10,
      async list(body: object) {
        body = {
          type: 1,
        };
        // 具体的API接口
        const url = `/screen/Index/getCompanyList`;
        // 需要针对Parms 进行处理
        const res = await request.get(url + "?" + qs.stringify(body));
        return res.data;
      },
      columns: (opts = {} as any) => {
        const { setCurrentRecord } = opts;
        return [
          {
            title: "序号",
            dataIndex: "",
            align: "center",
            render(_value: any, _record: any, index: number) {
              return index + 1;
            },
          },
          {
            title: "企业名称",
            align: "center",
            dataIndex: "name",
            render(_value: any, _record: any, index: number) {
              return (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setCurrentRecord?.(_record);
                  }}
                >
                  {_value}
                </div>
              );
            },
          },
        ];
      },
    },
  },
} as any;
